var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4001 7.60001C14.4001 7.91827 14.2736 8.22349 14.0486 8.44853C13.8235 8.67358 13.5183 8.80001 13.2 8.80001C12.8818 8.80001 12.5766 8.67358 12.3515 8.44853C12.1265 8.22349 12 7.91827 12 7.60001V2.80001C12 2.48175 12.1265 2.17652 12.3515 1.95148C12.5766 1.72643 12.8818 1.60001 13.2 1.60001C13.5183 1.60001 13.8235 1.72643 14.0486 1.95148C14.2736 2.17652 14.4001 2.48175 14.4001 2.80001V7.60001ZM11.2 7.73361V3.38961C11.2003 3.09236 11.1177 2.80093 10.9615 2.548C10.8054 2.29506 10.5819 2.09062 10.3161 1.95761L10.276 1.93761C9.83142 1.71538 9.34113 1.59979 8.84405 1.60001H4.51205C4.14203 1.59986 3.78339 1.72797 3.49721 1.96252C3.21102 2.19707 3.01497 2.52356 2.94245 2.88641L1.98245 7.68641C1.93604 7.91858 1.94174 8.15815 1.99913 8.38785C2.05653 8.61755 2.16418 8.83165 2.31433 9.01471C2.46448 9.19776 2.65339 9.34522 2.86742 9.44643C3.08146 9.54765 3.31529 9.6001 3.55205 9.60001H6.40005V12.8C6.40005 13.2244 6.56862 13.6313 6.86868 13.9314C7.16874 14.2314 7.5757 14.4 8.00005 14.4C8.21222 14.4 8.41571 14.3157 8.56573 14.1657C8.71576 14.0157 8.80005 13.8122 8.80005 13.6V13.0664C8.80005 12.374 9.02462 11.7003 9.44005 11.1464L10.5601 9.65361C10.9755 9.0997 11.2 8.42599 11.2 7.73361Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDown);
export default __webpack_public_path__ + "static/media/ThumbDown.a9c5b26b37e6513c9471d6d3530312d5.svg";
export { ForwardRef as ReactComponent };